import { render } from "./BaseProjectManagementAnswers.vue?vue&type=template&id=523f5190"
import script from "./BaseProjectManagementAnswers.vue?vue&type=script&lang=js"
export * from "./BaseProjectManagementAnswers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__